import CategoryActivity from './CategoryActivity'

export default CategoryActivity
